"use client";

import { useTranslation } from '@/lib';
import { ENV } from '@/lib/env';
import { ConsentManager as BaseConsentManager } from '@ui/composites/Consent';

export default function ConsentManager() {
  const { ts } = useTranslation();

  return (
    <BaseConsentManager
      gaId={ENV.GA_ID}
      translations={{
        consentMessage: ts('generic.consent_message'),
        acceptCookies: ts('generic.accept_cookies')
      }}
    />
  );
}
